import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Label } from "../ui/label";
import { Input } from "../ui/input";

const STATUSES = [
  { value: "todo", label: "To Do" },
  { value: "in_progress", label: "In Progress" },
  { value: "retensi", label: "Retensi" },
  { value: "review", label: "Review" },
  { value: "done", label: "Done" },
];

export default function ExportFilters({ format, setFormat, projectId, setProjectId, assignee, setAssignee,
  status, setStatus, dueFrom, setDueFrom, dueTo, setDueTo, projects, users }) {
  return (
    <>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label>Format</Label>
          <Select value={format} onValueChange={setFormat}>
            <SelectTrigger data-testid="export-format-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="pdf" data-testid="export-format-pdf">PDF (with evidence)</SelectItem>
              <SelectItem value="xlsx" data-testid="export-format-xlsx">Excel (.xlsx)</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label>Project</Label>
          <Select value={projectId} onValueChange={setProjectId}>
            <SelectTrigger data-testid="export-project-select"><SelectValue placeholder="All projects" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all" data-testid="export-project-all">All projects</SelectItem>
              {projects.map((p) => (
                <SelectItem key={p.id} value={p.id} data-testid={`export-project-${p.id}`}>{p.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label>Assignee</Label>
          <Select value={assignee} onValueChange={setAssignee}>
            <SelectTrigger data-testid="export-assignee-select"><SelectValue placeholder="All members" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all" data-testid="export-assignee-all">All members</SelectItem>
              {users.map((u) => (
                <SelectItem key={u.id} value={u.id} data-testid={`export-assignee-${u.id}`}>{u.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label>Status</Label>
          <Select value={status} onValueChange={setStatus}>
            <SelectTrigger data-testid="export-status-select"><SelectValue placeholder="All statuses" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all" data-testid="export-status-all">All statuses</SelectItem>
              {STATUSES.map((s) => (
                <SelectItem key={s.value} value={s.value} data-testid={`export-status-${s.value}`}>{s.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label>Due date from</Label>
          <Input type="date" value={dueFrom} onChange={(e) => setDueFrom(e.target.value)} data-testid="export-due-from" />
        </div>
        <div className="space-y-1.5">
          <Label>Due date to</Label>
          <Input type="date" value={dueTo} onChange={(e) => setDueTo(e.target.value)} data-testid="export-due-to" />
        </div>
      </div>
    </>
  );
}
